// extracted by mini-css-extract-plugin
export default {"item_wrapper":"PreoperativeTestsRepeater_item_wrapper__fbAQE","button_wrapper":"PreoperativeTestsRepeater_button_wrapper__36MNa"};